<template>
    <div class="tw-w-full tw-mb-6">
        <section :class="theme === 'dark' ? 'tw-bg-[#1A1D21]' : 'tw-bg-white'" class="tw-rounded-2xl tw-p-6 tw-shadow-2xl">
            <div class="tw-mb-8">
                <h2 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold tw-text-xl">Aeração</h2>
            </div>
            <div class="tw-mb-8">
                <div class="tw-flex tw-gap-6">
                    <button
                        @click="activateTabStatus(true)"
                        :class="[
                            'tw-pb-4 tw-font-semibold tw-text-sm',
                            tabStatus
                                ? 'tw-text-emerald-600 tw-border-b-2 tw-border-emerald-600'
                                : (theme === 'dark' ? 'tw-text-slate-400 hover:tw-text-slate-300' : 'tw-text-slate-500 hover:tw-text-slate-600')
                        ]"
                    >
                        Status
                    </button>
                    <button
                        @click="activatetabHistorico(true)"
                        :class="[
                            'tw-pb-4 tw-font-semibold tw-text-sm',
                            tabHistorico
                                ? 'tw-text-emerald-600 tw-border-b-2 tw-border-emerald-600'
                                : (theme === 'dark' ? 'tw-text-slate-400 hover:tw-text-slate-300' : 'tw-text-slate-500 hover:tw-text-slate-600')
                        ]"
                    >
                        Histórico Semanal
                    </button>
                </div>
            </div>
            <div v-if="tabStatus">
                <div v-if="aeracao && aeracao.aeracao" class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 tw-mb-6">
                    <div class="tw-flex tw-flex-col tw-gap-4 tw-relative"> <div class="tw-flex tw-flex-col tw-gap-4">
                            <div class="tw-flex tw-items-center tw-gap-3 tw-p-2">
                                <div class="tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-rounded-lg" :style="{ backgroundColor: statusColor + '20' }">
                                    <svg class="tw-w-5 tw-h-5" :style="{ color: statusColor }" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                                    </svg>
                                </div>
                                <div class="tw-flex-1">
                                    <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-600'" class="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wider">Status</p>
                                    <p :style="{ color: statusColor }" class="tw-font-bold tw-text-sm">{{ statusMotor }}</p>
                                </div>
                            </div>

                            <div class="tw-flex tw-items-center tw-gap-3 tw-p-2">
                                <div :class="theme === 'dark' ? 'tw-bg-blue-500/20' : 'tw-bg-blue-100'" class="tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-rounded-lg">
                                    <svg class="tw-w-5 tw-h-5 tw-text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.49 3.17c-.325-1.423-2.655-1.423-2.98 0a1.724 1.724 0 01-2.573 1.066c-1.248-.75-2.91.912-2.16 2.16a1.724 1.724 0 01-1.066 2.573c-1.423.325-1.423 2.655 0 2.98a1.724 1.724 0 011.066 2.573c-.75 1.248.912 2.91 2.16 2.16a1.724 1.724 0 012.573 1.066c.325 1.423 2.655 1.423 2.98 0a1.724 1.724 0 012.573-1.066c1.248.75 2.91-.912 2.16-2.16a1.724 1.724 0 011.066-2.573c1.423-.325 1.423-2.655 0-2.98a1.724 1.724 0 01-1.066-2.573c.75-1.248-.912-2.91-2.16-2.16a1.724 1.724 0 01-2.573-1.066zM10 13a3 3 0 100-6 3 3 0 000 6z"/>
                                    </svg>
                                </div>
                                <div class="tw-flex-1">
                                    <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-600'" class="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wider">Programa</p>
                                    <p :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold tw-text-sm">{{ descricaoPrograma }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="tw-flex tw-flex-col tw-relative"> 
                        <div v-if="aeracao && aeracao.horas_aeradas" 
                            class="tw-flex tw-flex-col tw-p-4 tw-shadow-sm">
                            <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" 
                            class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-widest tw-mb-3">
                                Horas Aeradas Totais
                            </p>
                            <div class="tw-flex tw-items-center tw-gap-1">
                                <svg class="tw-w-3.5 tw-h-3.5 tw-text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 8v4l2.5 2.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <span :class="theme === 'dark' ? 'tw-text-emerald-400' : 'tw-text-emerald-700'" class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-tight">
                                    {{ horasAeradasFormatadas }}
                                </span>
                            </div>
                        </div>
                        <div v-if="programa.numero != 8" 
                            class="tw-flex tw-flex-col tw-rounded-xl tw-p-4 tw-shadow-sm">
                            
                            <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" 
                            class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-widest tw-mb-3">
                                Configuração do Programa
                            </p>

                            <div class="tw-flex tw-flex-wrap tw-gap-2">
                                
                                <div v-if="[1, 2].includes(programa.numero)" class="tw-flex tw-flex-col tw-items-center tw-gap-0.5 tw-px-3 tw-py-2 tw-rounded-lg tw-bg-orange-500/10 tw-border tw-border-orange-500/20">
                                    <span class="tw-text-orange-500 tw-text-[10px] tw-font-black">TEMPERATURA</span>
                                    <span :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-text-xs tw-font-bold">
                                        {{ aeracao.aeracao.parametros.temperatura_minima }}° - {{ aeracao.aeracao.parametros.temperatura_maxima }}°C
                                    </span>
                                </div>
                                <div v-if="[1, 2, 3].includes(programa.numero)" class="tw-flex tw-flex-col tw-items-center tw-gap-0.5 tw-px-3 tw-py-2 tw-rounded-lg tw-bg-blue-500/10 tw-border tw-border-blue-500/20">
                                    <span class="tw-text-blue-500 tw-text-[10px] tw-font-black">UMIDADE</span>
                                    <span :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-text-xs tw-font-bold">
                                        {{ aeracao.aeracao.parametros.umidade_minima }}° - {{ aeracao.aeracao.parametros.umidade_maxima }}°C
                                    </span>
                                </div>
                                <div v-if="programa.numero === 2" class="tw-flex tw-flex-col tw-items-center tw-gap-0.5 tw-px-3 tw-py-2 tw-rounded-lg tw-bg-emerald-500/10 tw-border tw-border-emerald-500/20">
                                    <span class="tw-text-emerald-500 tw-text-[10px] tw-font-black">HORÁRIO</span>
                                    <span :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-text-xs tw-font-bold">
                                        {{ aeracao.aeracao.parametros.horario_inicio }} - {{ aeracao.aeracao.parametros.horario_final }}
                                    </span>
                                </div>
                                <div v-if="[4, 5 ,6 ,7].includes(programa.numero)" class="tw-flex tw-flex-col tw-items-center tw-gap-0.5 tw-px-3 tw-py-2 tw-rounded-lg tw-bg-purple-500/10 tw-border tw-border-purple-500/20">
                                    <span class="tw-text-purple-500 tw-text-[10px] tw-font-black">MÉDIA</span>
                                    <span :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-text-xs tw-font-bold">
                                        {{ aeracao.aeracao.parametros.media }}ºC
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="aeracao && aeracao.motores && aeracao.aeracao && aeracao.aeracao.data" class="tw-mb-6">
                    <MotorList 
                        :motores="aeracao.motores" 
                        :aeracao-data="aeracao.aeracao.data" 
                        :modoOperacao="modoOperacao"
                        :theme="theme"
                    />
                </div>
            </div>

            <!-- Chart Tab -->
            <div v-else>
                <div style="min-height: 400px">
                    <canvas id="aeracaoChart" style="max-height: 350px"></canvas>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import MotorList from './MotorList.vue';
import { Chart } from 'chart.js';
import { nextTick } from 'vue';

export default {
    components: {
        MotorList
    },
    props: {
        aeracao: {
            type: Object
        },
        modoOperacao: {
            type: Number
        },
        programa: {
            default: () => ({})
        },
        theme: {
            type: String,
            default: 'light'
        }
    },
    data() {
        return {
            tabStatus: true,
            tabHistorico: false,
            chart: null,
        }
    },
    watch: {
        theme() {
            if (this.tabHistorico) {
                nextTick(() => {
                    this.renderChart();
                });
            }
        },
    },
    methods: {
        activateTabStatus (action) {
            this.tabStatus = action;
            this.tabHistorico = false;
        },
        activatetabHistorico (action) {
            this.tabHistorico = action;
            this.tabStatus = false;
            nextTick(() => {
                this.renderChart();
            });
        },

        renderChart() {
            if (this.aeracao && this.aeracao.aeracao && this.aeracao.horas_aeradas && this.aeracao.horas_aeradas.horas_week) {
                const canvas = document.getElementById('aeracaoChart');
                if (!canvas) {
                    console.error('Canvas aeracaoChart não encontrado');
                    return;
                }

                const dados = this.aeracao.horas_aeradas.horas_week;
                const labels = this.getLast7Days();
                const hours = labels.map(date => {
                    const buscaDados = dados.find(item => item.date === date);
                    const totalHoras = buscaDados ? buscaDados.total_horas / 3600 : 0;
                    return totalHoras;
                });

                if (this.chart) {
                    this.chart.destroy();
                }

                const ctx = canvas.getContext('2d');
                const isDark = this.theme === 'dark';
                const textColor = isDark ? '#cbd5e1' : '#334155';
                const gridColor = isDark ? '#334155' : '#e2e8f0';
                
                this.chart = new Chart(ctx, {
                    type: 'bar',
                    data: {
                        labels: labels,
                        datasets: [{
                            label: 'Total de Horas',
                            data: hours,
                            backgroundColor: '#10b981',
                            borderColor: '#059669',
                            borderWidth: 1,
                            fill: true,
                            borderRadius: 6,
                            size: 10
                        }]
                    },
                    options: {
                        plugins: {
                            legend: {
                                labels: {
                                    color: textColor,
                                    font: { size: 12 }
                                }
                            },
                            title: {
                                display: true,
                                text: 'Histórico de Aeração',
                                color: textColor,
                                font: {
                                    size: 14,
                                    weight: 'bold'
                                }
                            },
                            subtitle: {
                                display: true,
                                text: 'Últimos 7 dias: Tempo Aerado',
                                color: textColor,
                                font: {
                                    size: 12
                                }
                            },
                        },
                        scales: {
                            x: {
                                title: {
                                    display: true,
                                    text: 'Data',
                                    color: textColor
                                },
                                ticks: {
                                    color: textColor
                                },
                                grid: {
                                    color: gridColor
                                },
                                reverse: true
                            },
                            y: {
                                title: {
                                    display: true,
                                    text: 'Total de Horas',
                                    color: textColor
                                },
                                ticks: {
                                    color: textColor
                                },
                                grid: {
                                    color: gridColor
                                },
                                beginAtZero: true
                            }
                        },
                        responsive: true,
                        maintainAspectRatio: false
                    }
                });
            }
        },



        getLast7Days() {
            const today = new Date();
            const dates = [];
            for (let i = 6; i >= 0; i--) {
                const date = new Date(today);
                date.setDate(today.getDate() - i);
                dates.push(this.formatDate(date));
            }
            return dates;
        },

        formatDate(date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        formatarDataPTBR(dataISO) {
            const data = new Date(dataISO);
            
            const dia = String(data.getDate()).padStart(2, '0');
            const mes = String(data.getMonth() + 1).padStart(2, '0'); 
            const ano = data.getFullYear();

            const horas = String(data.getHours()).padStart(2, '0');
            const minutos = String(data.getMinutes()).padStart(2, '0');
            const segundos = String(data.getSeconds()).padStart(2, '0');

            return `${dia}/${mes}/${ano} ${horas}:${minutos}:${segundos}`;
        }
    },
    computed: {
        statusMotor() {
            if (this.aeracao && this.aeracao.aeracao) {
                if (this.aeracao.aeracao.modo_operacao == 0) {
                    return "Aeração no manual";
                } else if (this.aeracao.aeracao.bloqueio_aeracao == 1) {
                    return "Aeração bloqueada";
                } else {
                    return "Aeração automática";
                }
            }
            return "";
        },
        statusColor() {
            switch (this.statusMotor) {
                case "Aeração no manual":
                    return "#ff9800";
                case "Aeração bloqueada":
                    return "#ff9800";
                case "Aeração automática":
                    return "#33b35a";
                default:
                    return "#000";
            }
        },
        descricaoPrograma() {
            if (this.aeracao && this.aeracao.aeracao) {
                switch (this.programa.numero) {
                    case 1:
                        return "Programa Livre"        
                    case 2:
                        return "Programa Livre Temporizado"
                    case 3:
                        return "Programa Equilibrio Higroscopico"
                    case 4:
                        return "Programa Curva 1"    
                    case 5:
                        return "Programa Curva 2"   
                    case 6:
                        return "Programa Curva 3"   
                    case 7:
                        return "Programa Curva 4"       
                    case 8:
                        return "Programa Personalizado"       
                    default:
                        return ""
                }
            }
            return ""
        },
        horasAeradasFormatadas() {
            if (this.aeracao && this.aeracao.horas_aeradas && this.aeracao.horas_aeradas.horas_all) {
                const totalSegundos = this.aeracao.horas_aeradas.horas_all;

                const horas = Math.floor(totalSegundos / 3600);
                const minutos = Math.floor((totalSegundos % 3600) / 60);
                const segundos = totalSegundos % 60;

                return `${horas} Hrs ${minutos} min ${segundos} secs`;
            }
            return "";
        },

        dataInicio() {
            if (this.aeracao && this.aeracao.horas_aeradas && this.aeracao.horas_aeradas.data_primeira_aeracao) {
                const data = this.aeracao.horas_aeradas.data_primeira_aeracao.data_inicio;
                return  this.formatarDataPTBR(data);
            }

            return ""
        }
    },
}
</script>
